import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibModuleOptions, MOL_LIB_TOKEN } from './lib.config';
import { LayerListModule } from './components/map/layer-list/layer-list.module';
import { LegendModule } from './components/map/legend/legend.module';
import { MapService } from './services/map.service';
import {
  HanhChinhService,
  LayerListService,
  ThongTinQuyHoachService,
  SliderOpacityService,
  AppConfigService,
} from './services';

@NgModule({
  imports: [CommonModule, LayerListModule, LegendModule],
  exports: [LayerListModule, LegendModule],
})
export class LibModule {
  static forRoot(options: LibModuleOptions): ModuleWithProviders {
    return {
      ngModule: LibModule,
      providers: [
        MapService,
        HanhChinhService,
        LayerListService,
        ThongTinQuyHoachService,
        SliderOpacityService,
        AppConfigService,
        {
          provide: MOL_LIB_TOKEN,
          useValue: options,
        },
      ],
    };
  }
}
